export default __webpack_public_path__ + "static/furgonetas-escolares-70a7902dd3f517d55a4274ae8c291067.png";